import { Chat } from '@/shared/interfaces/Chat'
import { ApiHandler } from '@/shared/api/ApiHandler'

export async function chatsGetPaged(
  folderId: number,
  page: number,
): Promise<{ chats: Chat[]; page_count: number, page: number }> {
  return await ApiHandler.get(
    'chats', {folder_id: folderId, page},
  )
}
